import { render, staticRenderFns } from "./SecKillConfig.vue?vue&type=template&id=0c0304aa&scoped=true"
import script from "./SecKillConfig.vue?vue&type=script&lang=js"
export * from "./SecKillConfig.vue?vue&type=script&lang=js"
import style0 from "./SecKillConfig.vue?vue&type=style&index=0&id=0c0304aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0304aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0304aa')) {
      api.createRecord('0c0304aa', component.options)
    } else {
      api.reload('0c0304aa', component.options)
    }
    module.hot.accept("./SecKillConfig.vue?vue&type=template&id=0c0304aa&scoped=true", function () {
      api.rerender('0c0304aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/secKill/SecKillConfig.vue"
export default component.exports